import { render, staticRenderFns } from "./SalesOrderListTable.vue?vue&type=template&id=b0d9a794"
import script from "./SalesOrderListTable.vue?vue&type=script&lang=js"
export * from "./SalesOrderListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports